
import {Options, Vue} from 'vue-class-component';
import './../less/contact.less'
import Gallery from "@/components/Gallery.vue";
import ContactForm from "@/components/ContactForm.vue";
import RegistrationForm from "@/components/RegistrationForm.vue";
import Logo from "@/components/Logo.vue";

@Options({
    components: {
        Gallery,
        ContactForm,
        RegistrationForm,
        Logo,
    },
})
export default class ContactPage extends Vue {
    isOpenMenu = false

    mounted(){
        document.title = 'HBA - Kapcsolat'
    }
    menuToggle() {
        this.isOpenMenu = !this.isOpenMenu
    }
}
